import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_2 = { class: "col-sm-12 text-right d-flex justify-content-end" }

import {ref, computed} from 'vue'
import Message from "./Message.vue";
import {formatDateEnToIT} from '../../filters/common.filters.js'
import {useChecklistStore, usePraticaStore} from "../../store/crm.store";


export default {
  __name: 'NoteDocumenti',
  props: {
  /**
   * file dove agganciare le note
   */
  file: {
    type: [Array, Object],
    default() {
      return null
    }
  },
  /**
   * indice dell'array dove il file appartiene
   */
  fileIndex: {
    type: [String, Number],
    default: 0
  },
  /**
   * elemento del questionario
   */
  element: {
    type: [Array, Object],
    default() {
      return {}
    }
  }
},
  setup(__props) {

/**
 * @doc
 * Si occupa di renderizzare le note legate ai documenti della checklist
 */
const props = __props

const checklistStore = useChecklistStore();
const praticaStore = usePraticaStore()

const toggleInserimentoNota = ref(false);
const notaAggiunta = ref({value: null});

const aggiugiNotaCondition = computed(() => {
  if (praticaStore.tipoUtenteConnesso === 'notaio') {
    return (!props.file.note || !toggleInserimentoNota.value && !props.file.is_blocked && !props.file.note.length > 0)
  } else {
    let noteCondition = (!props.file.note || props.file.note.length <= 0) || (props.file.note[0].mittente_id !== props.file.note[0].soggetto_id);
    let checklistCondition = (!toggleInserimentoNota.value && props.file.bozza !== 0 && checklistStore.questionarioTemplate.is_to_do);
    return noteCondition && checklistCondition;
  }
})

/**
 * Al momento vi è un limite dove si può inserire una sola nota per documento per controparte
 * Ovvero un documento, una nota per il notaio e una nota per il cliente
 * @param file
 * @param nota
 * @return {boolean|boolean}
 */
const disabilitaRispondi = (file, nota) => {
  let cittadinoCondition = ((nota.mittente_id === nota.soggetto_id || checklistStore.questionarioAttivoStatus === 'readonly') && praticaStore.tipoUtenteConnesso === 'cittadino');
  let generalCondition = (file.note.length >= 2);
  let disabilitaLatoNotaio = (praticaStore.tipoUtenteConnesso === 'notaio') && (file.is_blocked !== null);
  if (praticaStore.tipoUtenteConnesso === 'notaio') {
    (file.note).forEach(function (nota) {
      if (nota.scritto_da_notaio === 1) {
        disabilitaLatoNotaio = disabilitaLatoNotaio || (file.note.length < 2);
      }
    })
  }

  return cittadinoCondition || generalCondition || disabilitaLatoNotaio;
}

/**
 * Aggiunge nell'elenco degli elementi la nota che si dovrà salvare
 */
const inserisciNotaNelloStore = () => {
  checklistStore.onAggiungiNotaDaPostare({file: props.file, value: (notaAggiunta.value).value, element: props.element});
}

return (_ctx, _cache) => {
  const _component_base_textarea_floating_label = _resolveComponent("base-textarea-floating-label")

  return (__props.file)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          (aggiugiNotaCondition.value)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "my-1 c-pointer ps-3 ms-4 d-inline-block text-primary",
                onClick: _cache[0] || (_cache[0] = _withModifiers($event => (toggleInserimentoNota.value = true), ["prevent"]))
              }, " Aggiungi nota "))
            : _createCommentVNode("v-if", true)
        ]),
        (__props.file.note && __props.file.note.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[4] || (_cache[4] = _createElementVNode("u", { class: "mt-2" }, [
                _createElementVNode("strong", { class: "ps-2 ms-1" }, "Nota:")
              ], -1 /* CACHED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.file.note, (nota) => {
                return (_openBlock(), _createBlock(Message, {
                  key: nota.messaggio_id,
                  autore: nota.mittente,
                  description: nota.body,
                  "data-inserimento": _unref(formatDateEnToIT)(nota.created_at),
                  "disable-cta": disabilitaRispondi(__props.file,nota),
                  onRispondiNota: _cache[1] || (_cache[1] = $event => (toggleInserimentoNota.value= true))
                }, null, 8 /* PROPS */, ["autore", "description", "data-inserimento", "disable-cta"]))
              }), 128 /* KEYED_FRAGMENT */))
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        (toggleInserimentoNota.value)
          ? (_openBlock(), _createBlock(Message, { key: 1 }, {
              content: _withCtx(() => [
                _createVNode(_component_base_textarea_floating_label, {
                  name: "scrivi_una_nota",
                  label: "Scrivi una nota",
                  validateTo: notaAggiunta.value,
                  "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((notaAggiunta).value = $event)),
                  onInputOnBlur: inserisciNotaNelloStore
                }, null, 8 /* PROPS */, ["validateTo"]),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("button", {
                    class: "btn btn-primary mt-2",
                    onClick: _cache[3] || (_cache[3] = _withModifiers($event => {_unref(checklistStore).onInviaNotaDiUnFile({file: __props.file, value: notaAggiunta.value.value ? notaAggiunta.value.value : '', element: __props.element}); toggleInserimentoNota.value= false}, ["prevent"]))
                  }, "Inserisci")
                ])
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}
}

}